import { render, staticRenderFns } from "./DashboardLocation.vue?vue&type=template&id=8150c41e&scoped=true&"
import script from "./DashboardLocation.vue?vue&type=script&lang=js&"
export * from "./DashboardLocation.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLocation.vue?vue&type=style&index=0&id=8150c41e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8150c41e",
  null
  
)

export default component.exports